module.exports = __webpack_public_path__ + "static/media/muffito_logo.f8610181.png";